import { nanoid } from "nanoid"
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { api, baseURL, superAdminReqConfig } from "../../include/api"
import Error from "../add-ons/Error"
import Spinner from "../add-ons/Spinner"
import SuperAdminHeader from "./Header"

const SuperAdminNavigation = () => {
    const [fetchLoading, setFetchLoading] = useState(true)
    const [categoryList, setCategoryList] = useState([])
    const [searchQuery, setSearchQuery] = useState("")

    useEffect(() => {
        getCategory()
    }, [])

    const getCategory = (afterGet) => {
        setFetchLoading(true)
        api.get("/category/", superAdminReqConfig()).then(response => {
            if (response.status === 200) {
                setCategoryList(response.data.data)
                if (afterGet) afterGet(response.data.data)
            }
        }).catch(error => {
            setCategoryList([])
            if (afterGet) afterGet([])
        }).finally(() => setFetchLoading(false))
    }

    const handleSearch = (event) => {
        setSearchQuery(event.target.value)
    }

    const filteredCategories = categoryList.filter(category =>
        category.name.toLowerCase().includes(searchQuery.toLowerCase())
    )

    return <SuperAdminHeader >
        <div className="fixed-top-bar">
            <div className="container mt-2 mb-5">
                <div className="py-3 d-flex justify-content-between align-items-center">
                    <h5 className="m-0">Home Navigation</h5>
                    <Link to="/super/add-navigation" className="btn btn-success" >Add New Navigate</Link>
                </div>
                <div className="mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search navigations..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                </div>
                {fetchLoading ?
                    <Spinner color="danger" spinnerSize="lg" /> :
                    filteredCategories.length > 0 ?
                        // <div className="row">
                        //     {filteredCategories.filter(f => String(f.parentId) === '3').map((category, index) => {
                        //         return <Category category={category} key={nanoid()} />
                        //     })}
                        // </div> 
                        <table className="table table-bordered table-striped">
  <thead className="table-dark">
    <tr>
      <th>#</th>
      <th>Image</th>
      <th>Name</th>
      <th>Description</th>
      <th>Parent</th>
      <th>Edit</th>
    </tr>
  </thead>
  <tbody>
    {filteredCategories
      .filter(f => String(f.parentId) === '3')
      .map((category, index) => (
        <tr key={nanoid()}>
          <td>{index + 1}</td>
          <td style={{ width: "80px" }}>
            <img
              src={baseURL + "/" + category.imageUrl}
              alt=""
              className="img-fluid"
              style={{ maxHeight: "50px" }}
            />
          </td>
          <td>{category.name}</td>
          <td>{category.description}</td>
          <td>{category.parentId === -1 ? "Home" : category.parentName}</td>
          <td>
            <Link
              to={`/super/edit-navigation/${category.id}`}
              className="btn btn-sm btn-primary"
            >
              Edit
            </Link>
          </td>
        </tr>
      ))}
  </tbody>
</table> : <Error mainText="No category found!" secondaryText={<Link to="/super/add-category">Add New category</Link>} />}
            </div>
        </div>
    </SuperAdminHeader>
}

const Category = ({ category }) => {
    return <div className="col-12 col-md-6 col-lg-4 col-xl-3 p-2">
        <div className="border shadow-sm w-100 h-100 d-block">
            <div className="img-md w-100 p-3 border-bottom d-flex justify-content-center">
                <img src={baseURL + "/" + category.imageUrl} alt="" className="fit-contain w-100 h-100" />
            </div>
            <div className="p-2">
                <h6 className="d-flex align-items-center justify-content-between fw-bold">
                    <div className="text-truncate">{category.name}</div>
                    <Link to={`/super/edit-navigation/${category.id}`} className="small d-flex align-items-center hover-underline">Edit <i className="fas fa-pencil-alt fa-sm ps-2" />
                    </Link>
                    {/* <button className="btn btn-link p-0 ms-2">
                        <i className="fas fa-trash-alt fa-sm text-danger" />
                    </button> */}
                </h6>
                <p className="small mb-1 text-truncate text-muted">
    Parent: {
        category.parentId === -1
            ? "Home"
            : (category.name === category.parentName ? "Itself" : category.parentName)
    }
</p>

                <p className="text-truncate small m-0 remove-margin-bottom" >{category.description}</p>
            </div>
        </div>
    </div>
}

export default SuperAdminNavigation